import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import * as fromFittings from '../fromFittings.barrel';
import * as fromUser from '../fromUser.barrel';
import * as fromErrors from '../fromErrors.barrel';
import * as fromActions from '../actions/errors.actions';

export const errorsFeatureKey = 'errors';

export interface State {
  httpErrors: HttpErrorResponse[];
  generalErrors: Error[];
}

export const initialState: State = {
  httpErrors: [],
  generalErrors: []
};

export const reducer = createReducer(
  initialState,
  on(fromActions.addGlobalError, (state, action) => ({
    ...state,
    httpErrors: state.httpErrors.concat(action.error)
  }))
);
